// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Pending_wrapper__2JQfK","extraMargin":"Pending_extraMargin__2kMnU","ovals":"Pending_ovals__2pHrN","oval":"Pending_oval__2qycp","latest":"Pending_latest__ejb66"};